import { FC, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { CardContent, CircularProgress, Typography } from '@mui/material';
import { PropertyListItem } from '@atoms';
import { OPERATIONS, CLIENT } from '@globalConstants';
import { CompanyPostalAddress } from '@modules/clients/data/PlacesRepository/address/services/getPostalAddressByCustomerId';
import styles, { propertyListItemStyle } from './PostalAddressDetail.styles';

interface PostalAddressDetailProps {
  companyPostalAddress: CompanyPostalAddress | undefined;
  isLoading: boolean;
  isOperationRole: boolean;
}

/** Render company details address */
const PostalAddressDetail: FC<PostalAddressDetailProps> = ({
  companyPostalAddress,
  isLoading,
  isOperationRole,
}) => {
  const { t } = useTranslation();

  const floorAndAparment =
    companyPostalAddress &&
    (companyPostalAddress?.floor || companyPostalAddress?.apartment
      ? `${companyPostalAddress?.floor ?? ''}/${companyPostalAddress?.apartment ?? ''}`
      : '');

  const Items = useMemo(
    () => [
      { label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:STREET', value: companyPostalAddress?.street },
      { label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:NUMBER', value: companyPostalAddress?.number },
      { label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:FLOOR_AND_APARMENT', value: floorAndAparment },
      { label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:CITY', value: companyPostalAddress?.cityName },
      {
        label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:POSTAL_CODE',
        value: companyPostalAddress?.postalCode,
      },
      { label: 'CLIENTS:DETAIL:POSTAL_ADDRESS:STATE', value: companyPostalAddress?.stateName },
    ],
    [companyPostalAddress, floorAndAparment]
  );
  if (isLoading) return <CircularProgress sx={styles.spinner} size={48} />;

  if (!companyPostalAddress)
    return (
      <CardContent>
        <Typography>
          {isOperationRole
            ? t(`CLIENTS:DETAIL:DONT_HAVE_POSTAL_ADDRESS:${OPERATIONS.toUpperCase()}`)
            : t(`CLIENTS:DETAIL:DONT_HAVE_POSTAL_ADDRESS:${CLIENT.toUpperCase()}`)}
        </Typography>
      </CardContent>
    );

  return (
    <CardContent>
      <Typography variant='h2'>{t('CLIENTS:DETAIL:POSTAL_ADDRESS:TITLE')}</Typography>
      {Items.map((item) => (
        <PropertyListItem
          key={item.label}
          customStyle={propertyListItemStyle}
          label={item.label}
          value={item.value}
        />
      ))}
    </CardContent>
  );
};

export default PostalAddressDetail;
